import { useStore } from 'effector-react'
import { inspectionModel } from '~/entities/Inspection'
import { mileageFormat } from '~/shared/lib/utils'
// import { myPalette } from '~/shared/ui/theme'
import { ItemWrapper, Title, Value } from './styled'

export function Header() {
  const inspection = useStore(inspectionModel.$inspection)

  // const violationsCount = inspection?.getViolations()?.length
  const mileage = inspection?.getMileage()

  return (
    <div style={{ marginBottom: '24px' }}>
      <ItemWrapper>
        <Title>Пробег</Title>
        <Value>{mileageFormat(mileage)} км</Value>
      </ItemWrapper>
      {/*  <ItemWrapper>*/}
      {/*    <Title>Нарушения</Title>*/}
      {/*    <Value*/}
      {/*      style={{*/}
      {/*        color: violationsCount*/}
      {/*          ? myPalette.coral.main*/}
      {/*          : myPalette.limeGreen['600'],*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      {violationsCount || 0}*/}
      {/*    </Value>*/}
      {/*  </ItemWrapper>*/}
    </div>
  )
}
